export default __webpack_public_path__ + "static/media/tb-team-saydd.53d828c6.png";